// extracted by mini-css-extract-plugin
module.exports = {"caption":"ImageCaption_caption__-AwFr","title":"ImageCaption_title__381Kr","materials":"ImageCaption_materials__1FUDE"};